<template>
  <div>
    <section>
      <ul
        class="overall-menu"
        v-if="showHamBurgerIcon===false || (showHamBurgerIcon===true && changeToMobileScreen === false)"
      >
        <li class="sub-menu-parent" tab-index="0" v-for="(menuItem, i) in menuItems" v-bind:key="i">
          <a v-if="menuItem.componentName == ''" href="#">{{menuItem.name}}</a>

          <router-link v-if="menuItem.componentName == 'home'" :to="menuItem.componentName">
            <img src="../assets/home.png" class="imghome" />
          </router-link>
          <router-link
            v-else-if="menuItem.componentName != ''"
            :to="menuItem.componentName"
            tag="a"
          >{{menuItem.name}}</router-link>

          <ul class="sub-menu">
            <li v-for="(menuSubitem, j) in menuItem.childMenus" v-bind:key="j">
              <router-link
                :to="menuSubitem.componentName"
                tag="a"
                class="submenuitem"
              >{{menuSubitem.name}}</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <div class="sub-menu-parent">
        <div
          v-bind:class="{ containerburger: showHamBurgerIcon===true}"
          v-on:click="showHamBurgerIcon = !showHamBurgerIcon"
        >
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuItems: [
        {
          name: 'Home',
          id: 'home',
          componentName: 'home',
          childMenus: []
        },
        {
          name: 'Manage Sources',
          id: 'manageSource',
          componentName: '',
          childMenus: [
            {
              name: 'Add Dealer',
              id: 'addDealer',
              componentName: 'AddDealer',
              childMenus: []
            },
            {
              name: 'View/Update Dealer',
              id: 'viewUpdateDealer',
              componentName: 'viewUpdateDealer',
              childMenus: []
            },
            {
              name: 'Manage Inhouse',
              id: 'manageInhouse',
              componentName: 'manageInhouse',
              childMenus: []
            }
          ]
        },
        {
          name: 'Activity Tracking',
          id: 'activityTracking',
          componentName: '',
          childMenus: [
            {
              name: 'Schedule Activity',
              id: 'scheduleActivity',
              componentName: 'scheduleActivity',
              childMenus: []
            },
            {
              name: 'Manage Mileage',
              id: 'manageMileage',
              componentName: 'manageMileage',
              childMenus: []
            },
            {
              name: 'Add Task',
              id: 'addTask',
              componentName: 'addTask',
              childMenus: []
            },
            {
              name: 'Update Task',
              id: 'updateTask',
              componentName: 'updateTask',
              childMenus: []
            },
            {
              name: 'View Task',
              id: 'viewTask',
              componentName: 'viewTask',
              childMenus: []
            }
          ]
        },
        {
          name: 'Performance Tracking',
          id: 'performanceTracking',
          componentName: '',
          childMenus: [
            {
              name: 'My Dealers',
              id: 'assignedDealers',
              componentName: 'AssignedDealers',
              childMenus: []
            },
            {
              name: 'View Dashboard',
              id: 'viewDashBoard',
              componentName: 'ViewDashBoard',
              childMenus: []
            },
            {
              name: 'View Scorecard',
              id: 'viewScorecard',
              componentName: 'viewScorecard',
              childMenus: []
            },
            {
              name: 'View Assignments',
              id: 'viewAssignments',
              componentName: 'viewAssignments',
              childMenus: []
            }
          ]
        },
        {
          name: 'Deals Tracking',
          id: 'dealsTracking',
          componentName: '',
          childMenus: [
            {
              name: 'View Deals ',
              id: 'viewDeals',
              componentName: 'viewDeals',
              childMenus: []
            }
          ]
        },
        {
          name: 'Reporting',
          id: 'reporting',
          componentName: '',
          childMenus: [
            {
              name: 'My Task Notes',
              id: 'viewAgentTaskNotes',
              componentName: 'ViewAgentTaskNotes',
              childMenus: []
            },
            {
              name: 'Report an Issue',
              id: 'reportissue',
              componentName: 'ReportIssue',
              childMenus: []
            }
          ]
        },

        {
          name: 'Resource',
          id: 'resource',
          componentName: '',
          childMenus: [
            {
              name: 'Release Notes',
              id: 'releaseNotes',
              componentName: '',
              componentType: 'pdf',
              childMenus: []
            },
            {
              name: 'User Manual',
              id: 'userManual',
              componentName: '',
              componentType: 'xlsx',
              childMenus: []
            },
            {
              name: 'Help',
              id: 'help',
              componentName: 'llpHelp',
              childMenus: []
            }
          ]
        }
      ],
      showHamBurgerIcon: true,
      changeToMobileScreen: false
    }
  },
  mounted () {
    this.isMobileScreeen()
  },
  methods: {
    isMobileScreeen () {
      setInterval(() => {
        var w = window.innerWidth
        if (w < 1100) {
          this.changeToMobileScreen = true
        } else {
          this.changeToMobileScreen = false
        }
      }, 100)
    }
  },
  components: {}
}
</script>
<style scoped>
</style>
